import React, { Component } from 'react';
import { noop } from 'lodash';
import BackArrowView from './BackArrowView';
import { I_DONT_SEE_MY_PLAN } from '../ScanCardActions';
import { SectionHeader } from './StyledSectionComponents';
import SectionItemView from './SectionItemView';

export class ScanCardPlanView extends Component {
    static defaultProps = {
        clickPlan: noop,
        clickBackToCarrier: noop,
        recordNumberOfPlansDisplayed: noop,
    };

    render() {
        const {
            plans,
            clickBackToCarrier,
        } = this.props;

        const empty = {
            plan_id: I_DONT_SEE_MY_PLAN,
            plan_name: "I don't see my insurance plan here",
        };

        const plansWithEmpty = [...plans, empty];

        return (
            // TODO Chris what about long carrier names
            <div>
                <SectionHeader data-test="insurance-picker-scan-card-back-arrow" >
                    <BackArrowView
                        clickBack={clickBackToCarrier}
                        data-prod-guids="insurance-picker-scan-card-back-arrow:[003703d2]"
                        text="Select your plan"
                    />
                </SectionHeader>
                <div>
                    {plansWithEmpty.map((t, index) => this.renderInsurancePlanRow(t, index + 1))}
                </div>
            </div>
        );
    }

    renderInsurancePlanRow(item, index) {
        return (
            <SectionItemView
                key={item.plan_id}
                data-prod-guids={`plan-${item.plan_id}:[003703d2]`}
                dataTest={`plan-${item.plan_id}`}
                onClick={() => this.props.clickPlan(item, index, false)}
                text={item.plan_name}
            />
        );
    }

    componentDidMount() {
        if (!this.props.plans) {
            return;
        }

        this.props.recordNumberOfPlansDisplayed(this.props.plans);
    }
}
